// extracted by mini-css-extract-plugin
export default {"box":"Visits_box__UJAdh","visitRow":"Visits_visitRow__qglLA"};